import Vue from 'vue';
const resource = '/workorderitemorderitems';

export default {
  // CUSTOM ENDPOINT
  getByOrderItem(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `orderitems/${idPublic}${resource}`
    );
  },
};
